$(function () {
    //check if cart is visible when page load
    if(window.sessionStorage.getItem('open-cart') == 1) {
        $('.slide-cart').addClass('open-cart')
        window.sessionStorage.removeItem('open-cart')
    }


//close slide cart
    $('a.closeSlideCart').on('click', function () {
        $('.slide-cart').removeClass('open-cart')
    })

    $('.cart_background').on('click', function () {
        $('.slide-cart').removeClass('open-cart')
    })


    //open slide cart
    $('a.cart_link').on('click', function (e) {
        e.preventDefault();
        $('.slide-cart').addClass('open-cart')
    })


    // CHOOSE OPTIONS BUTTON
    $(document.body).on('click', '.btn_options', function(e) {
        if ( $(window).width() >= 992 ) {
            $(this).next('.quick_view_btn-slide-cart').trigger('click');
            e.preventDefault();
        }
    });



    //OPEN QUICK VIEW
    $(document.body).on('click', '.quick_view_btn-slide-cart', function(e) {
        e.preventDefault();

        // CONSTRUCTING QUICK VIEW MODAL
        $(document.body).append('<div id="product_quick_view" style="display: none;"><div class="product_quick_wrapper"><div class="quick_view__left"><div id="img_gallery__prev" class="swiper_btn btn_prev"></div><div id="img_gallery__next" class="swiper_btn btn_next"></div><div class="product_images"><div id="img_gallery" class="swiper-container"><div class="swiper-wrapper"></div></div></div><div id="img_big"></div></div><div class="quick_view__right"><form action="/cart/add" method="post" enctype="multipart/form-data" id="product-actions" class="quick_view_form"><p id="quick_view__name" class="product_name"></p><p id="quick_view__description"></p><p id="quick_view__type"><p class="single_product__compatible"><b>Compatible With:</b> <span>Zimmer® MIS® A.B. Dental® Alpha-Bio Tec® Adin® BioHorizons® Implant Direct®</span> </p> <span></span></p><p id="quick_view__variants"><select id="product-select" name="id" class="hidden"></select></p><div id="quick_view_colors"></div><div id="quick_view_size"></div><div id="quick_view__form"><p id="quick_view__price" class="product_price"></p><label for="quantity">Choose quantity:</label><div class="quantity_box"><span class="quantity_modifier quantity_down"><i class="fa fa-minus"></i></span><input min="1" type="text" name="quantity" value="1" class="quantity_input" /><span class="quantity_modifier quantity_up"><i class="fa fa-plus"></i></span></div><button class="btn btn-cart" type="submit" id="quick_view__add">Add to cart</button></div></form></div></div></div>');

        // SHOWING FANCYBOX LOADING ANIMATION
        $.fancybox.showLoading();
        $.fancybox.helpers.overlay.open({parent: $('body')});

        // GETTING PRODUCT INFO (JSON)
        $.getJSON( $(this).attr( 'href' ) + '.js', function( product ) {
            var product_to_use = product.product
            // TOGGLE BIG IMAGE WHEN CLICKING A THUMB
            $(document).on('click', '#img_gallery a', function(e) {
                e.preventDefault();
                var newHREF = $(this).attr('href');
                $('#product_quick_view #img_big img').attr('src', newHREF );
            });

            // PRODUCT TITLE
            var productTitle = product_to_use.title;

            $('#quick_view__name').html( '<a href="' + product_to_use.url + '">' + productTitle + '</a>' );

            // PRODUCT TYPE
            $('#quick_view__type span').html( product_to_use.type );


            // PRODUCT VARIANTS
            $.each(product_to_use.variants, function(i, variant) {
                $('#product-select').append('<option value="' + variant.id + '">' + variant.title + ' - ' + variant.price + '</option>')
            });

            // PRODUCT ALL INFO LINK
            $('#product_info_link a').attr( 'href', product_to_use.url );

            // QUANTITY FORM MINI
            $("#quantity").on("focusout",function(){var t=$(this).val();$(this).val(isNaN(parseFloat(t))&&!isFinite(t)||0==parseInt(t)||""==t?1:parseInt(t)<0?parseInt(t)-2*parseInt(t):parseInt(t))}),$("#quantity_up").on("click",function(){var t=$("#quantity").val();$("#quantity").val(!isNaN(parseFloat(t))&&isFinite(t)?parseInt(t)+1:1)}),$("#quantity_down").on("click",function(){var t=$("#quantity").val();$("#quantity").val(!isNaN(parseFloat(t))&&isFinite(t)&&t>1?parseInt(t)-1:1)});

            // UPLOADING option_selection.js TO MANAGE PRODUCT VARIANTS
            $.getScript( "//cdn.shopify.com/shopifycloud/shopify/assets/themes_support/option_selection-fe6b72c2bbdd3369ac0bfefe8648e3c889efca213baefd4cfb0dd9363563831f.js", function() {


                // IMAGES PRELOADER (FUNCTION)
                function preloadImages(images, callback) {
                    var count = images.length;
                    if (count === 0) {
                        callback();
                    }
                    var loaded = 0;
                    $(images).each(function() {
                        $('<img>').attr('src', this.src).load(function() {
                            loaded++;
                            if (loaded === count) {
                                callback();
                            }
                        });
                    });
                };

                // IMAGES PRELOADER (INIT)
                preloadImages( product_to_use.images, function() {

                    // APPENDING BIG IMAGE
                    var bigImgUrl = product_to_use.images[0].src.replace('.png', '_308x390_crop_center.png').replace('.jpg', '_308x390_crop_center.jpg');
                    $('#product_quick_view #img_big').append( '<img src="' + bigImgUrl + '" alt="" />' );

                    // APPENDING ALL IMAGES TO GALLERY
                    $.each(product_to_use.images, function(i, src) {
                        var smallSrc = src.src.replace('.png', '_90x90_crop_center.png').replace('.jpg', '_90x90_crop_center.jpg');
                        var bigSrc = src.src.replace('.png', '_308x390_crop_center.png').replace('.jpg', '_308x390_crop_center.jpg');
                        $('#img_gallery .swiper-wrapper').append( '<a class="swiper-slide" href="' + bigSrc + '"><img src="' + smallSrc + '" alt="" /></a>' );
                    });

                    // ADDING THUMBS SLIDER
                    var quickViewGallery = new Swiper('#img_gallery', {
                        direction: 'vertical',
                        height: 390,
                        speed: 500,
                        slidesPerView: 4,
                        spaceBetween: 10,
                        prevButton: '#img_gallery__prev',
                        nextButton: '#img_gallery__next',
                    });

                    // VARIANT CHANGE FUNCTION
                    var selectCallback = function(variant, selector) {
                        // if ( variant && variant.available ) {

                            jQuery('#quick_view__add').removeAttr('disabled').removeClass('disabled');

                            // VARIANT PRICES
                            if( variant.price < variant.compare_at_price ){
                                jQuery('#quick_view__price').html('<span class="money">' + formatMoney(variant.price) + '</span><span class="money compare-at-price money_sale">' + formatMoney(variant.compare_at_price) + '</span><span class="money_sale_percent">– ' + parseInt( 100 - ( variant.price*100 )/variant.compare_at_price ) + '%</span>');
                            }
                            else {
                                jQuery('#quick_view__price').html('<span class="money">' + formatMoney(variant.price) + '</span>');
                            };

                            // PRODUCT QUANTITY
                            if ( variant.inventory_management != null ) {
                                jQuery('#quick_view__availability span').removeClass('notify_danger').addClass('notify_success').html('Available');
                            }
                            else {
                                jQuery('#quick_view__availability span').removeClass('notify_danger').addClass('notify_success').html( 'Available' );
                            };

                        // COLOR & SIZE OPTIONS
                        for (var i = 0; i < selector.product.options.length; i++) {
                            if ( selector.product.options[i].name.toLowerCase() == 'color' ) {
                                var selectorNum = i;
                                var selectorName = selector.product.options[i].name;
                                renderColorOptions(selectorNum, selectorName);
                            };
                            if ( selector.product.options[i].name.toLowerCase() == 'size' ) {
                                var selectorNum = i;
                                var selectorName = selector.product.options[i].name;
                                renderSizeOptions(selectorNum, selectorName);
                            };
                            if(selector.product.options[i].name.toLowerCase() !== 'size' && selector.product.options[i].name.toLowerCase() !== 'color') {
                                var selectorNum = i;
                                var selectorName = selector.product.options[i].name;
                                renderOtherOptions(selectorNum, selectorName);
                            }
                        };


                        // CHANGING VARIANT IMAGE
                        if ( variant && variant.featured_image ) {
                            var originalImage = $("#img_big img");
                            var newImage = variant.featured_image.replace('.png', '_308x390_crop_center.png').replace('.jpg', '_308x390_crop_center.jpg');;
                            var element = originalImage[0];

                            Shopify.Image.switchImage(newImage, element, function (newImageSizedSrc, newImage, element) {
                                $('#img_big img').attr('src', newImageSizedSrc);
                            });
                        };

                        currencyToggle('#quick_view__price .money');
                    };

                    // VARIANT CHANGE FUNCTION (INIT)
                    new Shopify.OptionSelectors( "product-select",
                        {
                            product: product_to_use,
                            onVariantSelected: selectCallback,
                            enableHistoryState: false
                        });

                    // HIDING DEFAULT VARIANT SELECTOR
                    $.each( $('#quick_view__variants select option'), function() {
                        if ( $(this).val() == 'Default Title' ) {
                            $('#quick_view__variants').hide();
                        };
                    });

                    // SHOWING QUICK VIEW MODAL
                    $.fancybox( $('#product_quick_view'),
                        {
                            'openSpeed': 500,
                            'closeSpeed': 500,
                            'tpl': {
                                wrap: '<div id="quick_view__wrap" class="fancybox-wrap" tabIndex="-1"><div class="fancybox-skin"><div class="fancybox-outer"><div class="fancybox-inner"></div></div></div></div>',
                                closeBtn : '<a title="Close" id="quick_view__close" class="fancybox-item fancybox-close" href="javascript:;"></a>',
                            },
                            'afterClose': function() {
                                $('#product_quick_view').remove(); // REMOVING QUICK VIEW MODAL AFTER CLOSE
                            }
                        }
                    );

                });

            });


            function renderColorOptions(num, name) {
                var colorSelect = $('#product_quick_view .single-option-selector').eq(num);
                var selectId = '#' + colorSelect.attr('id');
                var container = $('#product_quick_view #quick_view_colors');
                var content = '<label>' + name + ': </label>';

                colorSelect.parent('.selector-wrapper').addClass('hidden');

                if ( $('#product_quick_view .single-option-selector').length == 1 ) {
                    $('#quick_view__variants label').hide();
                }

                $('#product_quick_view ' + selectId + ' option' ).each(function(){
                    var value = $(this).val();
                    if ( colorSelect.val() == value ) {
                        return content = content + '<div class="color_item current" data-val="' + value + '" title="' + value + '"><span class="color_inner" style="background-color: ' + value + '"></span></div>';
                    } else {
                        return content = content + '<div class="color_item" data-val="' + value + '" title="' + value + '"><span class="color_inner" style="background-color: ' + value + '"></span></div>';
                    }
                });

                container.html(content);

                $('#product_quick_view .color_item').on('click', function(e){
                    colorSelect.val( $(this).data('val') ).trigger('change');
                });
            };

            // RENDER SIZE OPTION
            function renderSizeOptions(num, name){
                var sizeSelect = $('#product_quick_view .single-option-selector').eq(num);
                var selectId = '#' + sizeSelect.attr('id');
                var container = $('#product_quick_view #quick_view_size');
                var content = '<label>' + name + ': </label>';

                sizeSelect.parent('.selector-wrapper').addClass('hidden');

                if ( $('#product_quick_view .single-option-selector').length == 1 ) {
                    $('#quick_view__variants label').hide();
                }

                $('#product_quick_view ' + selectId + ' option' ).each(function(){
                    var value = $(this).val();
                    if ( sizeSelect.val() == value ) {
                        return content = content + '<div class="size_item current" data-val="' + value + '"><span class="size_inner">' + value + '</span></div>';
                    } else {
                        return content = content + '<div class="size_item" data-val="' + value + '"><span class="size_inner">' + value + '</span></div>';
                    };
                });

                container.html(content);

                $('#product_quick_view .size_item').on('click', function(e){
                    sizeSelect.val( $(this).data('val') ).trigger('change');
                });

            };

            // RENDER OTHER OPTION
            function renderOtherOptions(num, name){
                $('label[for="product-select-option-' + num + '"]').text(name)
            };




            // CLOSING QUICK VIEW MODAL AFTER ADDING TO CART
            $('#quick_view__add').on('click', function() {
                $.fancybox.close();
            });

        });

    })

    //update cart on window load
    jQuery.get('/cart.js').done(function(response) {
        let items = JSON.parse(response).items
        jQuery('.items_table').html('');
        for(let i = 0; i < items.length; i++) {
            addProductToCart(items[i])
        }
        calculateCart(JSON.parse(response))
    })

    let $body = $('body');

    //prevent go to cart on updating product
    $body.on('submit', '.slide-cart-form',  function (e) {
        e.preventDefault();
        updateCart(this)
        // window.sessionStorage.setItem('open-cart', 1);
        // window.location.reload()
    })
    $body.on('click', '.slide-cart .cart_item__remove', function (e) {
        e.preventDefault();
        jQuery(this).parent().parent().find('.quantity_input').val(0)
        jQuery(this).parent().find('button').click()
        jQuery(this).parent().parent().parent().addClass('slideToLeft')
        let self = this;
        setTimeout(function(){
            jQuery(self).parent().parent().parent().remove()
        },600)

    })

    $body.on('click', 'a.btn.open_cart', function (e) {
        e.preventDefault();
        window.sessionStorage.setItem('open-cart', 1);
        window.location.reload()
        // window.sessionStorage.setItem('open-cart', 1);
        // window.location.reload()
    })

    $body.on('click', '#clear_cart_all_items', function (e) {
        e.preventDefault();
        jQuery.post('/cart/clear.js').done(function(){
            window.location.reload()
        })
        // window.sessionStorage.setItem('open-cart', 1);
        // window.location.reload()
    })

    $body.on('submit', 'form[action="/cart/add"]', function (e) {
        e.preventDefault();
        addToCart(e.target);
        // window.sessionStorage.setItem('open-cart', 1);
        // window.location.reload()
    })




    function updateCart (that){
        let updates = {}
        let variant_id = jQuery(that).find('button');
        let quantity = jQuery(that).find('.quantity_input')
        for(let i = 0; i < variant_id.length; i++) {
            updates[parseInt(jQuery(variant_id[i]).attr('variant-id'))] = parseInt(jQuery(quantity[i]).val())
        }
        jQuery.post('/cart/update.js', {
            updates
        }).done(function (response){
            calculateCart(JSON.parse(response));
        });
    }

    function addToCart (t, o) {
        var r = {
            type: "POST", url: "/cart/add.js", data: jQuery(t).serialize(), dataType: "json", success: function (r) {
                jQuery('div#fancybox-loading').hide()
                jQuery('.slide-cart').removeClass('open-cart')
                jQuery.get('/cart.js').done(function(response) {
                    let items = JSON.parse(response).items
                    jQuery('.items_table').html('');
                    for(let i = 0; i < items.length; i++) {
                        addProductToCart(items[i])
                    }
                    setTimeout(function(){
                        calculateCart(JSON.parse(response))
                        jQuery('.slide-cart').addClass('open-cart')
                    }, 500)
                })

            }, error: function (t, o) {
                Shopify.onError(t, o);
                var errorData = eval('(' + t.responseText + ')');
                $('body').append('<div id="cart_added" class="cart_error"><h4></h4><p class="alert alert-error"></p></div>');
                $('#cart_added h4').html(errorData.message);
                $('#cart_added p').html(errorData.description);
                $.fancybox.open($('#cart_added'), {
                    'openSpeed': 500, 'closeSpeed': 300, 'afterClose': function () {
                        $('#cart_added').remove()
                    }
                })
            }
        };
        jQuery.ajax(r)
    }

    function calculateCart (response) {



        //////////////////////////////
        //update cart button total
        //////////////////////////////
        jQuery('span#cart_items').text(response.item_count + ' item(s)')


        //////////////////////////////
        //calculate totals
        //////////////////////////////
        jQuery('.cart_totals span.total_price').text(formatMoney(response.total_price));
        jQuery('.cart_totals span.number_of_products').text(response.item_count);
        if(jQuery('.cart_totals span.before_discount').length == 0) {
            jQuery('.cart_totals span.total_price').addClass('after_discount');
            jQuery('<span class="before_discount"></span>').insertBefore('.cart_totals span.total_price');
        }
        if(jQuery('.cart_totals .order_now_message').length == 0) {
            jQuery('.cart_totals').append('<p class="order_now_message" style="display: none">Save <span class="percentage_amount"></span>% by ordering NOW!</p>');
        }

        if(response.item_count >= 10 && response.item_count <= 19) {
            jQuery('.cart_totals span.after_discount').text(formatMoney(response.total_price * 0.85))
            jQuery('.cart_totals span.before_discount').text(formatMoney(response.total_price))
            jQuery('.cart_totals span.percentage_amount').text(15)
            jQuery('.cart_totals .cart_total_savings .amount').text(formatMoney(response.total_price - response.total_price * 0.85))
            jQuery('.cart_totals .order_now_message').show()
            jQuery('.cart_totals span.before_discount').show()
            jQuery('.cart_totals .cart_total_savings').show()
        } else if(response.item_count >= 20 && response.item_count <= 29) {
            jQuery('.cart_totals span.after_discount').text(formatMoney(response.total_price * 0.8))
            jQuery('.cart_totals span.before_discount').text(formatMoney(response.total_price))
            jQuery('.cart_totals span.percentage_amount').text(20)
            jQuery('.cart_totals .cart_total_savings .amount').text(formatMoney(response.total_price - response.total_price * 0.8))
            jQuery('.cart_totals .order_now_message').show()
            jQuery('.cart_totals span.before_discount').show()
            jQuery('.cart_totals .cart_total_savings').show()
        } else if(response.item_count >= 30) {
            jQuery('.cart_totals span.after_discount').text(formatMoney(response.total_price * 0.7))
            jQuery('.cart_totals span.before_discount').text(formatMoney(response.total_price))
            jQuery('.cart_totals span.percentage_amount').text(30)
            jQuery('.cart_totals .cart_total_savings .amount').text(formatMoney(response.total_price - response.total_price * 0.7))
            jQuery('.cart_totals .order_now_message').show()
            jQuery('.cart_totals span.before_discount').show()
            jQuery('.cart_totals .cart_total_savings').show()
        } else {
            jQuery('.cart_totals span.before_discount').hide()
            jQuery('.cart_totals .order_now_message').hide()
            jQuery('.cart_totals .cart_total_savings').hide()
        }

        //////////////////////////////
        //calculate products
        //////////////////////////////
        let allItems = jQuery('.single_item');
        if(jQuery('.item_final_price .before_discount').length === 0) {
            jQuery('<span class="before_discount" style="display: none"></span>').insertBefore('.item_final_price .after_discount')
        }

        for(let i = 0; i < allItems.length; i++) {
            let product_calculated_price = response.items[i].final_line_price;

            if(response.item_count >= 10 && response.item_count <= 19) {
                jQuery(allItems[i]).find('p.item_final_price span.after_discount').text(formatMoney((product_calculated_price * 0.85)))
                jQuery(allItems[i]).find('p.item_final_price span.before_discount').text(formatMoney((product_calculated_price)))
                jQuery(allItems[i]).find('p.item_final_price span.before_discount').show()
            } else if(response.item_count >= 20 && response.item_count <= 29) {
                jQuery(allItems[i]).find('p.item_final_price span.after_discount').text(formatMoney(((product_calculated_price * 0.8))))
                jQuery(allItems[i]).find('p.item_final_price span.before_discount').text(formatMoney((product_calculated_price)))
                jQuery(allItems[i]).find('p.item_final_price span.before_discount').show()
            } else if(response.item_count >= 30) {
                jQuery(allItems[i]).find('p.item_final_price span.after_discount').text(formatMoney(((product_calculated_price * 0.7))))
                jQuery(allItems[i]).find('p.item_final_price span.before_discount').text(formatMoney((product_calculated_price)))
                jQuery(allItems[i]).find('p.item_final_price span.before_discount').show()
            } else {
                jQuery(allItems[i]).find('p.item_final_price span.after_discount').text(formatMoney((product_calculated_price)))
                jQuery('p.item_final_price span.before_discount').hide()
            }
            // let product_quantity = jQuery(allItems[i]).find('.quantity_input').val();
        }

        //////////////////////////////
        //calculate free shipping
        //////////////////////////////

        
        
        if (response.total_price/100 < 299) {
            jQuery('.free_shipping').html("Only " + formatMoney(299*100 - (response.total_price)) + " left for free shipping!");
        } else {
            jQuery('.free_shipping').html("<i class=\"fa fa-truck\"></i>YES! You are eligible for free shipping 😊");
        }


    }

    function formatMoney(value) {
        return Shopify.formatMoney(value, theme.moneyFormat).replace(/ /, ',');
    }

    //////////////////////////////
    //add products to cart
    //////////////////////////////
    function addProductToCart(item){
        let variants = '';
        for(let v = 0; v < item.options_with_values.length; v++) {
           variants += '<span><b>'+ item.options_with_values[v].name +'</b>: '+ item.options_with_values[v].value +'</span><br>'
        }
        jQuery('.items_table').prepend(
        '<div class="single_item">' +
            '<div class="item_image">' +
            '<img class="cart__image" src="'+ item.image +'" alt="'+ item.title +'">' +
            '</div>' +
            '<div class="item_data">' +
            '<p class="cart_item__name product_name">' +
            '<a href="'+ item.url +'">'+ item.product_title +'<span class="tdf-cart-item-t"></span></a>' +
            '</p>' +
            '<p class="cart_item__variant">' + variants +
            '</p>' +
            '<div class="item_price">' +
            '<b>Unit price:</b> $' + item.price/100 +
            '</div>' +
            '<div class="choose_variants slide-cart-variant-button">' +
            '<a class="btn_options" href="'+ item.url +'">Add different Diameters/Lengths</a>' +
            '<a class="quick_view_btn-slide-cart" style="display: none" href="'+ item.url +'" title="Quick view"><i class="fa fa-search-plus" aria-hidden="true"></i></a>' +
            '</div>' +
            '<div class="item_buttons">' +
            '<div class="quantity_box item_quantity">' +
            '<span class="quantity_down"><i class="fa fa-minus" aria-hidden="true"></i></span>' +
            '<input id="updates_'+ item.id +'" name="updates[]" value="' + item.quantity + '" class="quantity_input" type="text">' +
            '<span class="quantity_up"><i class="fa fa-plus" aria-hidden="true"></i></span>' +
            '<button type="submit" name="update" variant-id="'+ item.variant_id +'" class="btn">Update</button>' +
            '</div>' +
            '<a class="btn cart_item__remove" href="/cart/change?line=2&amp;quantity=0"><i class="fa fa-trash"></i></a>' +
            '</div>' +
            '</div>' +
            '<div class="item_total_price">' +
            '<p class="item_final_price">' +
            '<span class="before_discount"></span>' +
            '<span class="after_discount">$' + item.original_line_price/100  + '</span>' +
            '</p>' +
            '</div>' +
            '</div>');
    }
});
